skrilla.controller('chargebackDetailsCtrl', function ($scope, searchService, $stateParams, srefService, modalService, cacheService) {
    $scope.calculatedAmount = 0;
    $scope.get = function() {
        searchService.get("chargeBacks/" + $stateParams.id).then(function (response) {
            $scope.report = response.data;
            $scope.calculatedAmount = $scope.report.entities.reduce((a, b) => a + b.fee, 0);
        })
    }

    $scope.get()


    $scope.navigate = function(entity){
        let location = "depositDetails";
        if(entity.entityType === "BET"){
            location = "betDetails"
        }
        else if(entity.entityType === "WITHDRAWAL"){
            location = "withdrawalDetails"
        }
        srefService.go(location, {id: entity.entityId})
    }

    $scope.addEntity = function(){
        cacheService.registerObject("chargeBackReport", $scope.report)
        modalService.openModal("views/chargebacks/addEntityToChargeBack.html", true, 'lg', true, true, $scope.get);
    }

});
